import { EPeriod, EPeriodDays, ERightType, type TPaywallSlotProduct } from '@/apis/commerce';
import { resolvePeriodCount } from '@/utils/pay/all-period';

/**
 * 将 Period 单位天数 × 归一后的 period_count 得到展示天数。
 * Quarter/ThreeDay 的 count 按 1；缺省 count 按 1。映射不到返回 undefined，调用方不得默默当 7 天。
 * @param period Period 枚举值
 * @param periodCount 接口 period_count，可缺省
 */
export function resolvePeriodDays(period?: number, periodCount?: number): number | undefined {
    if (period == null) {
        return undefined;
    }
    const count = resolvePeriodCount(period, periodCount);
    if (count == null) {
        return undefined;
    }
    const name = EPeriod[period] as keyof typeof EPeriodDays | undefined;
    if (!name || !(name in EPeriodDays)) {
        return undefined;
    }
    return EPeriodDays[name] * count;
}

/**
 * 轮播卡展示天数：RT=3 无 period 时跟现网兜底 7 天；RT=2 / RT=4 必须能映射。
 */
export function resolveCarouselPassDays(product: TPaywallSlotProduct): number | undefined {
    const days = resolvePeriodDays(product.period, product.period_count);
    if (product.right_type === ERightType.FullBook) {
        return days ?? 7;
    }
    return days;
}
